// BrandLockup — the approved remembr logo lockup with the FMN icon
// CENTERED ABOVE the wordmark. Use this wherever the main brand mark
// appears (nav, footer, hero, path chooser, etc).
//
// Spec: /app/memory/BRAND_GUIDELINES.md §5.
import { ForgetMeNotIcon } from "./ForgetMeNotIcon";

/**
 * <BrandLockup size="md" tagline />
 *
 * @param {object}  props
 * @param {"xs"|"sm"|"md"|"lg"|"xl"} props.size  — preset size token
 * @param {boolean} props.tagline                 — show tagline beneath wordmark
 * @param {"colour"|"mono"} props.variant         — icon variant
 * @param {string}  props.wordmarkClass           — extra classes on the wordmark span
 * @param {string}  props.className               — extra wrapper classes
 */
export function BrandLockup({
    size = "md",
    tagline = false,
    variant = "colour",
    wordmarkClass = "",
    className = "",
}) {
    const sizing = {
        xs: { icon: 24, word: "text-base sm:text-lg",   tag: "text-[9px] tracking-[0.18em]",  gap: "gap-0.5" },
        sm: { icon: 32, word: "text-lg sm:text-xl",     tag: "text-[10px] tracking-[0.18em]", gap: "gap-1"    },
        md: { icon: 40, word: "text-2xl sm:text-3xl",   tag: "text-xs tracking-[0.18em]",     gap: "gap-1.5"  },
        lg: { icon: 56, word: "text-3xl sm:text-4xl",   tag: "text-sm tracking-[0.18em]",     gap: "gap-2"    },
        xl: { icon: 80, word: "text-4xl sm:text-5xl",   tag: "text-base tracking-[0.2em]",    gap: "gap-3"    },
        "2xl": { icon: 108, word: "text-5xl sm:text-6xl", tag: "text-base sm:text-lg tracking-[0.22em]", gap: "gap-3" },
    }[size];

    return (
        <span className={`inline-flex flex-col items-center ${sizing.gap} ${className}`}>
            <ForgetMeNotIcon size={sizing.icon} variant={variant} />
            <span
                className={`font-serif italic font-medium text-[#2D2B2A] tracking-tight leading-none ${sizing.word} ${wordmarkClass}`}
            >
                remembr
            </span>
            {tagline && (
                <span className={`block font-serif italic text-[#5C5A59] mt-1 text-center whitespace-nowrap leading-tight ${sizing.tag}`}>
                    yesterday &nbsp;·&nbsp; today &nbsp;·&nbsp; tomorrow
                    <span className="block mt-0.5 animate-fmn-breathe motion-reduce:animate-none">forget me not.</span>
                </span>
            )}
        </span>
    );
}
